import { useNavigate, useSearchParams } from 'react-router'

import { DipsResource } from '~/storm'
import { isNumber } from '~/utils/utils'

// keys used to distinguish between showing edit or new form
const formNavigationParams = {
    edit: 'entityId',
    new: 'dipsResourceId',
}

const getIdParam = (value: string | undefined | null) => (!!value && isNumber(value) ? Number(value) : null)

export const useResourceNavigation = () => {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const entityId = getIdParam(searchParams.get(formNavigationParams.edit))
    const dipsResourceId = getIdParam(searchParams.get(formNavigationParams.new))

    const navigateWithPreviousParams = (params: Record<string, string | undefined>) => {
        const newParams = new URLSearchParams(window.location.search)
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                newParams.set(key, value)
            } else {
                newParams.delete(key)
            }
        })
        return navigate({ search: newParams.toString() })
    }

    const navigateToList = () => navigateWithPreviousParams({ [formNavigationParams.edit]: undefined, [formNavigationParams.new]: undefined })

    const navigateToEdit = (id: number) => navigateWithPreviousParams({ [formNavigationParams.edit]: id.toString() })

    const navigateToNew = (dipsResourceId: DipsResource['id']) => navigateWithPreviousParams({ [formNavigationParams.new]: dipsResourceId.toString() })

    return { entityId, dipsResourceId, navigateWithPreviousParams, navigateToEdit, navigateToNew, navigateToList }
}
